import paymentService from '../../../../services/payment-service.js'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'

import Modal from 'react-modal'
import MDInput from '../../../../components/MDComponents/MDInput'
import { useState, useCallback } from 'react'
import MDBox from '../../../../components/MDComponents/MDBox'
import CloseIcon from '@mui/icons-material/Close'
import Swal from 'sweetalert2'
import Button from '../../../../components/Button'

import judete from './judete.json'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px',
    backgroundColor: 'rgb(var(--container-background))',
  },
}

const sectoare = [
  'Sector 1',
  'Sector 2',
  'Sector 3',
  'Sector 4',
  'Sector 5',
  'Sector 6',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
]

const PaymentModal = ({ subscription, handleCloseModal, onPaymentSuccess }) => {
  const stripe = useStripe()
  const elements = useElements()

  const [name, setName] = useState('')
  const [address, setAddress] = useState('')
  const [judet, setJudet] = useState('')
  const [localitate, setLocalitate] = useState('')

  const [judetError, setJudetError] = useState(false)
  const [localitateError, setLocalitateError] = useState(false)

  const [payButtonClicked, setPayButtonClicked] = useState(false)

  const labelsFont =
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif'

  const normalize = text => {
    return text
      .toLowerCase()
      .replace(/\s/g, '')
      .replace('ă', 'a')
      .replace('î', 'i')
      .replace('ș', 's')
      .replace('ț', 't')
      .replace('â', 'a')
  }

  const handleSubmit = useCallback(
    async e => {
      const arrayContains = (array, element) => {
        return array.map(el => normalize(el)).includes(normalize(element))
      }

      setPayButtonClicked(true)

      e.preventDefault()

      let hasError = false

      const judeteNume = judete.map(judet => judet.nume)
      let judetString = judet
      let localitateString = localitate

      if (arrayContains(judeteNume, judet)) {
        setJudetError(false)
        for (const jud of judeteNume) {
          if (normalize(jud) === normalize(judet)) {
            judetString = jud
          }
        }
      } else {
        Swal.fire({
          title: 'Informații incorecte',
          text: 'Județul nu există.',
          icon: 'error',
        })
        setJudetError(true)
        hasError = true
      }

      if (normalize(judet) === 'bucuresti') {
        if (arrayContains(sectoare, localitate)) {
          setLocalitateError(false)
          for (const sec of sectoare) {
            if (normalize(sec) === normalize(localitate)) {
              if (sec.length === 1) {
                localitateString = 'Sector ' + sec
              } else {
                localitateString = sec
              }
            }
          }
        } else {
          Swal.fire({
            title: 'Informații incorecte',
            text: 'Sectorul nu există.',
            icon: 'error',
          })
          hasError = true
          setLocalitateError(true)
        }
      } else {
        setLocalitateError(false)
      }

      if (hasError) {
        setPayButtonClicked(false)
        return
      }

      if (!stripe || !elements) {
        setPayButtonClicked(false)
        return
      }

      await paymentService.updateDateFacturare({
        date_facturare: {
          nume_client: name,
          adresa_client: address,
          judet: judetString,
          localitate: localitateString,
          type: 'fizic',
        },
      })

      const { error: submitError } = await elements.submit()
      if (submitError) {
        Swal.fire({
          title: 'Detalii incorecte',
          text: 'Verifică detaliile cardului!',
          icon: 'error',
        })
        setPayButtonClicked(false)
        return
      }

      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret: subscription['clientSecret'],
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: 'if_required',
      })

      if (error) {
        console.log('Error', error)
        // show error and collect new card details.
        Swal.fire({
          title: 'Plată respinsă!',
          text: 'Verifică detaliile cardului și soldul.',
          icon: 'error',
        })
        setPayButtonClicked(false)
        return
      }

      // confirm payment
      Swal.fire({
        title: 'Plată efectuată!',
        text: 'Plata a fost efectuată cu succes',
        icon: 'success',
      })
      onPaymentSuccess(subscription)
      handleCloseModal()
      setPayButtonClicked(false)
    },
    [
      elements,
      name,
      address,
      subscription,
      onPaymentSuccess,
      stripe,
      handleCloseModal,
      judet,
      localitate,
    ],
  )

  if (!stripe || !elements) {
    // Stripe.js has not loaded yet. Make sure to disable
    // form submission until Stripe.js has loaded.
    return ''
  }
  return (
    <Modal
      isOpen={subscription !== null}
      onRequestClose={handleCloseModal}
      style={customStyles}
      contentLabel="Payment Modal"
    >
      <MDBox className="!text-over-secondary-background" textAlign="right">
        <CloseIcon
          ml="auto"
          onClick={handleCloseModal}
          style={{
            cursor: 'pointer',
            color: 'rgb(var(--text-over-secondary-background))',
          }}
        />
      </MDBox>
      <form className="!bg-container-background" onSubmit={handleSubmit}>
        <label
          className="text-sm text-over-secondary-background"
          style={{ fontFamily: labelsFont }}
          htmlFor="name"
        >
          Nume
        </label>
        <MDInput
          id="name"
          type="text"
          variant="standard"
          fullWidth
          name="name"
          value={name}
          onChange={e => setName(e.target.value)}
          inputProps={{
            autoComplete: 'name',
            form: {
              autoComplete: 'off',
            },
            style: { fontSize: 16 },
          }}
        />
        <label
          className="text-sm text-over-secondary-background"
          style={{ fontFamily: labelsFont }}
        >
          Județ
        </label>
        <MDInput
          id="judet"
          type="text"
          variant="standard"
          fullWidth
          name="judet"
          value={judet}
          onChange={e => setJudet(e.target.value)}
          inputProps={{
            autoComplete: 'name',
            form: {
              autoComplete: 'off',
            },
            style: { fontSize: 16 },
          }}
          error={judetError}
        />
        <label
          className="text-sm text-over-secondary-background"
          style={{ fontFamily: labelsFont }}
          htmlFor="localitate"
        >
          Localitate / Sector
        </label>
        <MDInput
          id="localitate"
          type="text"
          variant="standard"
          fullWidth
          name="localitate"
          value={localitate}
          onChange={e => setLocalitate(e.target.value)}
          inputProps={{
            autoComplete: 'name',
            form: {
              autoComplete: 'off',
            },
            style: { fontSize: 16 },
          }}
          error={localitateError}
        />
        <label
          className="text-sm text-over-secondary-background"
          style={{ fontFamily: labelsFont }}
          htmlFor="address"
        >
          Adresă
        </label>
        <MDInput
          id="address"
          type="text"
          variant="standard"
          fullWidth
          name="address"
          value={address}
          onChange={e => setAddress(e.target.value)}
          inputProps={{
            autoComplete: 'name',
            form: {
              autoComplete: 'off',
            },
            style: { fontSize: 16 },
          }}
        />
        <br />
        <MDBox pt={2}>
          <PaymentElement
            options={{
              business: {
                name: process.env.REACT_APP_NAME,
              },
            }}
          />
        </MDBox>
        <div className="pt-3 flex justify-center">
          {subscription && (
            <Button
              type="submit"
              className="bg-primary text-over-primary "
              disabled={
                payButtonClicked ||
                subscription['id'] === undefined ||
                subscription['clientSecret'] === undefined
              }
            >
              Plătește {subscription.price / 100} RON
            </Button>
          )}
        </div>
      </form>
    </Modal>
  )
}
export default PaymentModal
